import { createAsyncThunk } from "@reduxjs/toolkit";
import { getStandardGeographies } from "api/getStandardGeographies";
import {
  resolveStandardGeography,
  TResolveStandardGeographyPayload,
} from "api/resolveStandardGeography";
import {
  IStandardGeographyDto,
  StandardGeographyTypeEnum,
} from "features/MarketAreas/types";
import type { RootState } from "store/rootReducer";
import { buildGeographyCacheKey } from "./buildGeographyCacheKey";

const readCache = (state: RootState, key: string) =>
  state.marketAreaAdministrativeGeography.geographyCache[key];

export const loadRootGeographies = createAsyncThunk<
  IStandardGeographyDto[],
  StandardGeographyTypeEnum,
  { state: RootState }
>(
  "marketAreaAdministrativeGeography/loadRoot",
  (type, { getState, signal }) => {
    const cached = readCache(getState(), buildGeographyCacheKey({ type }));
    if (cached) return cached;
    return getStandardGeographies({ type }, signal);
  }
);

export type TLoadChildGeographiesArgs = {
  parent: IStandardGeographyDto;
  childType: StandardGeographyTypeEnum;
};

export const loadChildGeographies = createAsyncThunk<
  IStandardGeographyDto[],
  TLoadChildGeographiesArgs,
  { state: RootState }
>(
  "marketAreaAdministrativeGeography/loadChildren",
  ({ parent, childType }, { getState, signal }) => {
    const params = {
      type: childType,
      parentLayer: parent.layer,
      parentId: parent.id,
    };
    const cached = readCache(getState(), buildGeographyCacheKey(params));
    if (cached) return cached;
    return getStandardGeographies(params, signal);
  }
);

export const resolveGeographyAtPoint = createAsyncThunk<
  IStandardGeographyDto,
  TResolveStandardGeographyPayload
>("marketAreaAdministrativeGeography/resolveAtPoint", (payload, { signal }) =>
  resolveStandardGeography(payload, signal)
);
